import NiceModal from '@ebay/nice-modal-react';

import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import Button from 'components/field/Button';
import FormHeader from 'components/global/FormHeader';
import { HeaderContainerFormHeader } from 'components/global/styled/FormHeader.styled';
import DynamicList from 'components/list/DynamicList';
import { FilterAction, FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { ENUMS, SHIPPING_PARTNERS } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons';

import DeliverySlotConfigurationForm from './DeliverySlotConfigurationForm';

/**
 * @author @s-uzgor
 */

export const DeliverySlotManagement = () => {
	const { state } = useLocation();

	const { settingsID, icon, name } = state;

	const defaultFilters = useMemo(
		() => [
			{
				column: {
					accessor: 'deliveryCompanySettingsId',
					Header: 'deliveryCompanySettingsId',
					filterType: FilterType.number
				},
				action: FilterAction.contains,
				value: settingsID
			}
		],
		[settingsID]
	);

	const columns = useMemo(
		() => [
			{ Header: 'ID', accessor: 'ID', filterType: FilterType.number, width: 70, show: false },
			{
				Header: 'warehouse',
				accessor: 'warehouse',
				filterType: FilterType.string
			},
			{
				Header: 'branch',
				accessor: 'branch',
				filterType: FilterType.string
			},
			{
				Header: 'deliverySlots',
				accessor: 'deliverySlots',
				filterType: FilterType.string,
				width: 100
			},
			{
				Header: 'days',
				accessor: 'days',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.DAY_OF_WEEK,
				width: 100
			},
			{
				Header: 'startDate',
				accessor: 'startDateInterval',
				width: 100,
				filterType: FilterType.date,
				renderCell: ListComponents.DATE
			},
			{
				Header: 'endDate',
				accessor: 'endDateInterval',
				width: 100,
				filterType: FilterType.date,
				renderCell: ListComponents.DATE
			},
			{
				Header: 'cutOffTime',
				accessor: 'cutoffDuration',
				filterType: FilterType.string
			},
			{
				Header: 'capacity',
				accessor: 'capacity',
				filterType: FilterType.number
			}
		],
		[]
	);

	return (
		<div>
			<HeaderContainerFormHeader>
				<FormHeader logo={icon} lightTitle={name} boldTitle="deliverySlotManagement" icon={faArrowLeft} />

				<Button
					lordIcon="https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/addOrder-icon.json.gz"
					label="addSlotConfiguration"
					onClick={() =>
						NiceModal.show(DeliverySlotConfigurationForm, {
							mode: 'add',
							deliveryCompanySettingsId: settingsID
						})
					}
					variant="blue"
					className="addButton"
				/>
			</HeaderContainerFormHeader>

			<DynamicList
				id={DYNAMICLISTS.DELIVERY_SLOT_MANAGEMENT}
				showFilters={false}
				defaultFilters={defaultFilters}
				columns={columns}
				fetchUrl={SHIPPING_PARTNERS.GET_DELIVERY_SLOT_LIST_METHOD}
				actionObjectType={ACTION_OBJECT_TYPES.DELIVERY_SLOT}
				exportName="deliverySlotList"
				showColumnCalculation={false}
			/>
		</div>
	);
};

export default DeliverySlotManagement;
